import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberFormat',
  standalone: true // Set to true if using Angular 14+
})
export class NumberFormatPipe implements PipeTransform {
  transform(value: number | string | null | undefined): string {
    if (value === null || value === undefined || value === '') return '';
    let numberValue = typeof value === 'string' ? parseFloat(value) : value;

    if (isNaN(numberValue)) return '';
    const roundedValue = Math.round(numberValue); 
    return new Intl.NumberFormat('en-IN', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      style: 'decimal' 
    }).format(roundedValue);
  }
}